export default { //存放变量的容器
  // 公共接口地址
  baseURL: 'https://yinshua2.yongx.asia/api/',
  // 上传图片地址
  imageUrl: 'https://yinshua2.yongx.asia/api/common/upload',
  // 图片拼接地址
  imgUrl: 'https://yinshua2.yongx.asia',
  fileUrl: '',
}

// 参考官网 https://www.juyiyinshua.com/   测试账号：15690888834 密码：1221bb